import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/uk-coaching-1st4sports-logo.png")